import React from 'react'
import { ContentHolderWrapper } from './style'

export const ContentHolder = (props: any) => (
  <ContentHolderWrapper className="isoExampleWrapper" style={props.style}>
    {props.children}
  </ContentHolderWrapper>
)
